var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyRef(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 2.66659V10.6666C5.3335 11.0202 5.47397 11.3593 5.72402 11.6094C5.97407 11.8594 6.31321 11.9999 6.66683 11.9999H12.0002C12.3538 11.9999 12.6929 11.8594 12.943 11.6094C13.193 11.3593 13.3335 11.0202 13.3335 10.6666V4.82792C13.3335 4.65029 13.298 4.47446 13.229 4.31075C13.1601 4.14704 13.0592 3.99875 12.9322 3.87459L10.7222 1.71325C10.4731 1.46969 10.1385 1.3333 9.79016 1.33325H6.66683C6.31321 1.33325 5.97407 1.47373 5.72402 1.72378C5.47397 1.97382 5.3335 2.31296 5.3335 2.66659V2.66659Z",
    stroke: "#E8E13F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 12V13.3333C10.667 13.6869 10.5265 14.0261 10.2765 14.2761C10.0264 14.5262 9.68728 14.6666 9.33366 14.6666H4.00033C3.6467 14.6666 3.30756 14.5262 3.05752 14.2761C2.80747 14.0261 2.66699 13.6869 2.66699 13.3333V5.99996C2.66699 5.64634 2.80747 5.3072 3.05752 5.05715C3.30756 4.8071 3.6467 4.66663 4.00033 4.66663H5.33366",
    stroke: "#E8E13F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyRef);
export default __webpack_public_path__ + "static/media/copy-ref.3550941c.svg";
export { ForwardRef as ReactComponent };